// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"79d53d37","640":"d4c92a6b","875":"4568fdb4","973":"a6a2e9d7"}[chunkId] + ".chunk.js";
};